import {FILTER_FIELD, FILTER_TO_TITLES} from "../views/components/FilterModalConsts";
import {TITLES} from "../types/GridTypes";

const HOME_BASE = 'TLV'

export class FiltersHandlers  {
    static handleNumberFilters(filter: any, item:any) {
        if(filter.operatorValue === 'gt') {
            return filter.value
                ? Number(item[FILTER_TO_TITLES[filter?.field as FILTER_FIELD]]) > Number(filter.value)
                : true;
        }if(filter.operatorValue === 'gte') {
            return filter.value
                ? Number(item[FILTER_TO_TITLES[filter?.field as FILTER_FIELD]]) >= Number(filter.value)
                : true;
        }
        if(filter.operatorValue === 'lt') {
            return filter.value
                ? Number(item[FILTER_TO_TITLES[filter?.field as FILTER_FIELD]]) < Number(filter.value)
                : true;

        }
        if(filter.operatorValue === 'lte') {
            return filter.value
                ? Number(item[FILTER_TO_TITLES[filter?.field as FILTER_FIELD]]) < Number(filter.value)
                : true;
        }
        return filter.value
            ? Number(item[FILTER_TO_TITLES[filter?.field as FILTER_FIELD]]) === Number(filter.value)
            : true;
    }
    static handleStringFilters(filter: any, item:any) {
        if(filter.operatorValue === 'eq') {
            return filter.value
                ? item[FILTER_TO_TITLES[filter?.field as FILTER_FIELD]] === filter.value
                : true;
        }
        if(filter.operatorValue === 'neq') {
            return filter.value
                ? item[FILTER_TO_TITLES[filter?.field as FILTER_FIELD]] !== filter.value
                : true;
        }
        if(filter.operatorValue === 'contains') {
            return filter.value
                ? item[FILTER_TO_TITLES[filter?.field as FILTER_FIELD]].includes(filter.value)
                : true;
        }
        if(filter.operatorValue === 'ncontains') {
            return filter.value
                ? !item[FILTER_TO_TITLES[filter?.field as FILTER_FIELD]].includes(filter.value)
                : true;
        }
        return true;
    }
    static handleBooleanFilters(filter: any, item:any) {
        if(filter.operatorValue === 'eq') {
            return filter.value
                ? item[FILTER_TO_TITLES[filter?.field as FILTER_FIELD]] === filter.value
                : true;
        }
        return true;
    }

    static handleSpecialCases(filter: any, item:any) {
        switch (filter.field) {
            case FILTER_FIELD.HOME_BASE_TO:
                return FiltersHandlers.handleHomeBaseTo(filter, item);
            case FILTER_FIELD.ORIGIN_TO_HOME_BASE:
                return FiltersHandlers.handleOriginToHomeBase(filter, item);
            case FILTER_FIELD.MONTH_DUE_DATE:
                return FiltersHandlers.handleMonthDueDate(filter, item);
            case FILTER_FIELD.DAYS_AHEAD_FLIGHT:
                return FiltersHandlers.handleDaysAheadFlight(filter, item);
            case FILTER_FIELD.DURATION_BUCKET:
                return FiltersHandlers.handleDurationBucket(filter, item);
            case FILTER_FIELD.SEATS_ON_AIRCRAFT:
                return FiltersHandlers.handleSeatsOnAircraft(filter, item);
            case FILTER_FIELD.PRICE_GROUPS:
                return FiltersHandlers.handlePriceGroups(filter, item);
        }
    }

    private static handleMonthDueDate(filter: any, item: any) {
        const month = FiltersHandlers.getMonthFromDate(item[FILTER_TO_TITLES[filter?.field as FILTER_FIELD]]);
        if(filter.operatorValue === 'gt') {
            return filter.value
                ? month > Number(filter.value)
                : true;
        }
        if(filter.operatorValue === 'gte') {
            return filter.value
                ? month >= Number(filter.value)
                : true;
        }
        if(filter.operatorValue === 'lt') {
            return filter.value
                ? month < Number(filter.value)
                : true;
        }
        if(filter.operatorValue === 'lte') {
            return filter.value
                ? month < Number(filter.value)
                : true;
        }
        if(filter.operatorValue === 'eq') {
            return filter.value
                ? month === Number(filter.value)
                : true;
        }

    }

    private static handleDaysAheadFlight(filter: any, item: any) {
        const date = new Date(item[FILTER_TO_TITLES[filter?.field as FILTER_FIELD]]);
        const today = new Date();
        const diffTime = Math.abs(date.getTime() - today.getTime());
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        if(filter.operatorValue === 'gt') {
            return filter.value
                ? diffDays > Number(filter.value)
                : true;
        }
        if(filter.operatorValue === 'gte') {
            return filter.value
                ? diffDays >= Number(filter.value)
                : true;
        }
        if(filter.operatorValue === 'lt') {
            return filter.value
                ? diffDays < Number(filter.value)
                : true;
        }
        if(filter.operatorValue === 'lte') {
            return filter.value
                ? diffDays < Number(filter.value)
                : true;
        }
        if(filter.operatorValue === 'eq') {
            return filter.value
                ? diffDays === Number(filter.value)
                : true;
        }
    }

    private static handleHomeBaseTo(filter: any, item: any) {
        const isFitHomeBase = item[TITLES.FLIGHT_NAME].startsWith(HOME_BASE);
        const isAirport = filter.value === item[TITLES.DESTINATION_AIRPORT];
        const isCity = filter.value === item[TITLES.DESTINATION_CITY];
        const isCountry = filter.value === item[TITLES.DESTINATION_COUNTRY];
        const isFitDestination = isAirport || isCity || isCountry;
        return isFitHomeBase && isFitDestination
    }

    private static handleOriginToHomeBase(filter: any, item: any) {
        const isFitDestination = item[TITLES.FLIGHT_NAME].slice(-3) === HOME_BASE;
        const isAirport = filter.value === item[TITLES.ORIGIN_AIRPORT];
        const isCity = filter.value === item[TITLES.ORIGIN_CITY];
        const isCountry = filter.value === item[TITLES.ORIGIN_COUNTRY];
        const isFitOrigin = isAirport || isCity || isCountry;
        return isFitDestination && isFitOrigin
    }

    private static handleDurationBucket(filter: any, item:any) {
        const {max, min} = FiltersHandlers.convertHoursToMinutesRange(filter.value);
        const duration = FiltersHandlers.convertToMinutes(item[FILTER_TO_TITLES[filter?.field as FILTER_FIELD]]);
        return duration >= min && duration <= max;
    }

    private static handlePriceGroups(filter: any, item: any) {
        console.log('item', filter, item)
        const [minPrice, maxPrice] = filter.value.split('-').map((price:string) => parseFloat(price.trim()));
        const price = parseFloat(item[FILTER_TO_TITLES[filter?.field as FILTER_FIELD]]);
        return price >= minPrice && price <= maxPrice;
    }

    private static handleSeatsOnAircraft(filter: any, item: any) {

    }

    static getMonthFromDate(dateString:string) {
        const date = new Date(dateString);
        return date.getMonth() + 1;
    }

    static convertHoursToMinutesRange(input:string) {
        const [minHours, maxHours] = input.split('-').map(hour => parseFloat(hour.trim()) * 60);
        return { min: minHours, max: maxHours };
    }

    static convertToMinutes(input: string) {
        const parts = input.split(' ');
        let totalMinutes = 0;

        for (let part of parts) {
            if (part.endsWith('h')) {
                totalMinutes += parseInt(part) * 60;
            } else if (part.endsWith('m')) {
                totalMinutes += parseInt(part);
            }
        }

        return totalMinutes;
    }
}